import { PriceAnatomyMapper } from '../../../models/Price/PriceAnatomyMapper.js';

class Debug {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  isAvailable() {
    return this.apiClient.get('v1/debug-mode').then(_ref => {
      let {
        data: allowed
      } = _ref;
      return allowed;
    }).catch(() => false);
  }
  getPrice(params) {
    return this.apiClient.post('/v1/debug-mode/prices', params).then(_ref2 => {
      let {
        data: {
          services
        }
      } = _ref2;
      return services.map(PriceAnatomyMapper.createModelFromResponse);
    });
  }
}

export { Debug };
//# sourceMappingURL=Debug.js.map
